import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DynamicObjectInterface } from '../../../sdk/type';
import { useAPICall } from '../../../hooks';
import { AdminPageHeader, Button, ButtonStyles, Card, MLPVersion, DropDown, ButtonSize } from '../../../ui/components';
import { DropDownData } from '../../../ui/components/Form/DropDown/types/propsType';
import CampaignService from '../../../sdk/services/campaignService';
import ReportService from '../../../sdk/services/reportService';
import styles from './index.module.scss';

export interface ReportPropsType {
  title: string;
  campaignType: 'CHALLENGE' | 'PROMOTION';
  name?: 'team' | 'coach-group' | 'coach-individual' | 'leader' | 'inventory' | 'promo-redemption';
}

export interface Data {
  campaignRecId: string;
}

// export interface CampaignData {
//   value: string;
//   title: string;
// }

export const Report = (props: ReportPropsType) => {
  const location = useLocation();
  const apiCall = useAPICall();
  const [data, setData] = useState<Data | null>(null);
  const [campaignList, setCampaignList] = useState<DropDownData[]>();

  useEffect(() => {
    (async () => {
      let res = await apiCall(CampaignService?.getCampaigns);
      let campaignData = res?.data?.data ?? [];
      setCampaignList(
        campaignData
          ?.filter((i: DynamicObjectInterface) => 
            i.campaignType === props.campaignType &&
            i.status !== 'DELETED' &&
            i.status !== 'CLOSED'
          )
          ?.map((d: DynamicObjectInterface) => ({
            value: `${d.recId}`,
            title: `${d.campaignId} - ${d.campaignName}`,
            campaignId: d.campaignId,
            campaignName: d.campaignName,
            campaignStart: d.campaignStart,
            campaignEnd: d.campaignEnd,
          })),
      );
    })();
  }, []);

  useEffect(() => {
    setData(null);
  }, [location]);

  const handleExport = async () => {
    const payload = {
      campaignRecId: data?.campaignRecId,
      campaignId: campaignList?.find((i: DropDownData) => i.value === data?.campaignRecId)?.campaignId,
      campaignName: campaignList?.find((i: DropDownData) => i.value === data?.campaignRecId)?.campaignName,
      campaignStart: campaignList?.find((i: DropDownData) => i.value === data?.campaignRecId)?.campaignStart,
      campaignEnd: campaignList?.find((i: DropDownData) => i.value === data?.campaignRecId)?.campaignEnd,
    };

    const response = await apiCall(ReportService.getReport, props.name ?? '', payload);

    if (response?.status && response?.blob && response?.fileName) {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob);
      link.setAttribute('download', response.fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Release the object URL resources
      URL.revokeObjectURL(link.href);
    }
  };

  return (
    <div className={styles['report']}>
      <AdminPageHeader title={props.title} />

      <Card classes={styles['report-container']}>
        <DropDown
          name="campaignId"
          dropdownLabel={`Campaign*`}
          disabledFilter
          mlpVersion={MLPVersion.ONE}
          value={
            data?.campaignRecId
              ? campaignList?.find((i: DropDownData) => i.value === data?.campaignRecId)?.title?.toString()
              : ''
          }
          data={campaignList}
          configData={{
            label: 'title',
            onSelect: (selectedOption: DropDownData) => {
              setData(prevData => ({
                ...prevData!,
                campaignRecId: selectedOption.value?.toString(),
              }));
            },
          }}
        />
        <div className={styles['report-button']}>
          <Button
            buttonStyle={ButtonStyles.OUTLINE}
            size={ButtonSize.SMALL}
            title="Export"
            disabled={!data?.campaignRecId}
            onClick={handleExport}
          />
        </div>
      </Card>
    </div>
  );
};
